const openPopupsEls = []

/*
  Usage:
  <popup-element class="cart-drawer"
    data-id="cart-drawer"
    data-is-quickview
    role="dialog"
    inert
    aria-modal="true"
    aria-labelledby="id-of-title-element"
  >
    <h2 id="id-of-title-element">Cart items</h2>
  </popup-element>
*/

const popupElement = class extends HTMLElement {
  constructor() {
    super()

    this.isOpen = false
    this.setAttribute('aria-hidden', 'true')
    this.id = this.getAttribute('data-id')
    this.siteOverlay = document.querySelector('[data-site-overlay]')
    this.siteBody = document.body

    if (Shopify.designMode) {
      document.body.classList.add('shopify-customizer')

      document.addEventListener('shopify:section:load', () => {
        const activePopupId = window.localStorage.getItem('activePopup')

        if (activePopupId !== this.id) { return }

        this.isOpen = true
        this.handleOpen()
      })
    } else {
      this.initPopupElement()
    }

    this.quickviewModalInit()
  }

  initPopupElement() {
    document.body.insertAdjacentElement('beforeend', this)
  }

  handleOpen() {
    this.setAttribute('aria-hidden', 'false')
    this.siteOverlay.classList.add('active')
    this.classList.add('active')
    this.removeAttribute('inert')
    trapFocus.open(this)
    this.checkVideo()
    this.siteBody.classList.add('scroll-lock')
    openPopupsEls.push(this)
    this.updateSiteOverlayZindex()
  }

  handleClose() {
    this.setAttribute('aria-hidden', 'true')
    this.classList.remove('active')
    this.setAttribute('inert', '')
    this.siteBody.classList.remove('scroll-lock')

    if (Shopify.designMode) {
      window.localStorage.removeItem('activePopup')
      this.siteOverlay.classList.remove('active')
      document.body.classList.remove('shopify-customizer')
    }

    trapFocus.close()

    const thisPopupIndex = openPopupsEls.findIndex(popup => popup === this)
    thisPopupIndex > -1 && openPopupsEls.splice(thisPopupIndex, 1)
    this.siteOverlay.classList.remove('active')
  }

  updateSiteOverlayZindex() {
    const popupStyle = window.getComputedStyle(this)
    const popupZindex = popupStyle.getPropertyValue('z-index')
    this.siteOverlay.style.zIndex = popupZindex - 1
  }

  checkVideo(play) {
    if (!this.hasAttribute('data-autoplay-video')) { return }
    const videos = this.querySelectorAll('video')
    if (play === true) {
      videos.forEach((video, index) => {
        video.currentTime = 0
        if (index !== 0) { return }
        video.play()
      })
    } else {
      videos.forEach((video) => {
        video.pause()
      })
    }
  }

  quickviewModalInit() {
    if (!this.hasAttribute('data-is-quickview-modal')) { return }

    window.addEventListener('cartAPI', ({ detail: { cartData } }) => {
      this.open = false
    })
  }

  set open(isOpen) {
    if (isOpen === true) {
      this.handleOpen()
    } else if (isOpen === false) {
      this.handleClose()
    }
  }

  get open() {
    return this.isOpen
  }
}

if (typeof window.customElements.get('popup-element') === 'undefined') {
  window.customElements.define('popup-element', popupElement)
}

/*
  Usage:
  <popup-toggle data-target="cart-drawer" data-action="open">
    <button type="button">Open Cart</button>
  </popup-toggle>
*/
const popupToggle = class extends HTMLElement {
  constructor() {
    super()

    this.action = this.getAttribute('data-action')
    this.target = this.getAttribute('data-target')
    this.button = this.querySelector('button')
    this.targetEl = null
    this.initToggle()
  }

  initToggle() {
    this.button.addEventListener('click', () => {
      this.targetEl = document.querySelector(`popup-element[data-id="${this.target}"]`)

      if (!this.targetEl) { return }

      if (Shopify.designMode) {
        window.localStorage.setItem('activePopup', this.target)
      }

      this.targetEl.open = this.action === 'open'
    })
  }
}

if (typeof window.customElements.get('popup-toggle') === 'undefined') {
  window.customElements.define('popup-toggle', popupToggle)
}

document.addEventListener('DOMContentLoaded', () => {
  const siteOverlay = document.querySelector('[data-site-overlay]')

  if (siteOverlay) {
    siteOverlay.addEventListener('click', closeCurrentPopupEl)
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') { return }
    closeCurrentPopupEl()
  })

  function closeCurrentPopupEl() {
    const popupToClose = openPopupsEls[openPopupsEls.length - 1]

    if (!popupToClose) { return }

    popupToClose.open = false
  }
})
